<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/kidClass/listClass"
            create-url="/kidClass/save"
            delete-url="/kidClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="2"
            @viewItem="viewItem"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/account_class/ClassCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách các lớp học",
      formCreateName: "Thêm mới lớp học",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
/*        {
          value: 'classCode',
          text: 'Mã lớp',
          sortable: false,
          search: true,
          width: "10%",
          headerStyle: "text-align:center",
        },*/
        {
          value: 'className',
          text: 'Tên lớp',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: 'programId',
          text: 'Khung chương trình',
          width: "7%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "programId",
          items: [],
          itemText: "programName",
          itemValue: "programId",
        },
        {
          value: 'startDate',
          text: 'Ngày khai giảng',
          type: "date",
          sortable: true,
          search: true,
          width: "13%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate",
          toDate: "toDate"
        },
        {
          value: 'endDate',
          text: 'Ngày kết thúc',
          type: "date",
          sortable: true,
          search: true,
          width: "13%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDate1",
          toDate: "toDate1"
        },
        {
          value: 'progress',
          text: 'Tiến độ',
          sortable: false,
          search: true,
          width: "5%",
        },
        {
          value: 'weekNo',
          text: 'Week chuẩn',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center",
        },
        {
          value: 'classCurrentUnit',
          text: 'Unit chuẩn',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center",
        },

        {
          value: 'classCurrentLevel',
          text: 'Level chuẩn',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalKid',
          text: 'Tổng số học sinh',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center",
        },
        {
          value: 'totalKidSlow',
          text: 'Số học sinh học chậm',
          sortable: false,
          search: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'slowLearningRate',
          text: 'Tỉ lệ học sinh học chậm',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {

    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/accountClass/view/' + item.classId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
